var Backbone = require('backbone');

var BaseCollection = Backbone.Collection.extend({

    initialize: function(models, options) {
        if (options && options.params){
            this.url += "?" + options.params.map(function(param){return param.key + "=" + param.value}).join("&");
        }
    }
});

module.exports = BaseCollection;


//////////////////
// WEBPACK FOOTER
// ./app/collections/base-collection.js
// module id = 211
// module chunks = 0